/* eslint-disable react/jsx-pascal-case */
import React, { useRef, useState } from "react";
import { Palette, API_BASE } from "../AppConfig";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_Select from "../components/BSL_Select";
import BSL_Button from "../components/BSL_Button";
import RecallQuotesLayout from "./RecallQuotesLayout";
import { useSelector, useDispatch } from "react-redux";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import { fetchTimeout } from "../components/Common";
import { CLEAR_ALL_DESIGNER_MESSAGE, SHOW_MESSAGE, updateRecallListFromWeb } from "../redux_store/appState";
import { StyledTabs, StyledTab } from "../components/BSL_CommonControls";
import { NEW_JOB } from "../redux_store/jobState";
import { updateAPP, MAIN_PAGE } from "../redux_store/appState";
import debounce from "lodash/debounce";
import { useMemo } from "react";
import {
    BusinessIdEffect,
    containerModeEffect,
    useFetchJobPricesEffect,
    initialiseEffect,
    mainPageEffect,
    searchEffect,
    sortByEffect,
    tabIndexEffect,
} from "./component_effects/JobRecallPageEffects";
import { standard_cent_jobs, standard_lld_jobs } from "../redux_store/dummy_data";
import Message from "../components/Message";
import Select from "@material-ui/core/Select";
import AppsIcon from "@material-ui/icons/Apps";
import ListIcon from "@material-ui/icons/List";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { GetStateFromPOA } from "./ManageBusiness/BusinessList";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    page: {
        [theme.breakpoints.up("sm")]: {
            marginLeft: "170px",
            marginRight: "100px",
        },
        [theme.breakpoints.down("sm")]: {
            marginLeft: "80px",
            marginRight: "0px",
        },
        display: "flex",
        textAlign: "left",
        marginTop: "20px",
        minHeight: "600px",
        flexDirection: "column",
    },
    header: {
        fontWeight: "400",
        letterSpacing: "1px",
        paddingRight: "20px",
        verticalAlign: "text-top",
        color: theme.brand.LYSAGHT ? theme.palette.primary.light : Palette.Control.DarkGrey,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.brand.LYSAGHT ? "24pt" : "18pt",
        textTransform: theme.brand.LYSAGHT ? "uppercase" : "capitalize",
        fontWeight: theme.brand.LYSAGHT ? "800" : "inherit",
    },
    view_panel: {
        flexWrap: "wrap",
        marginLeft: "11px",
        display: "flex",
        alignItems: "center",
        font: "12pt " + theme.typography.fontFamily,
    },
    inline: {
        position: "relative",
        display: "inline-block",
    },
    search_container: {
        borderRadius: theme.brand.LYSAGHT ? "0px" : "50px",
        background: "white",
        border: "1px solid #6B8799",
    },
    search_icon: {
        color: theme.brand.LYSAGHT ? Palette.Lysaght.DarkBlue : "grey",
        width: "0.75em",
        height: "0.75em",
        marginLeft: "7px",
        verticalAlign: "-webkit-baseline-middle",
        marginTop: theme.brand.LYSAGHT ? "5px" : "inherit",
    },
    sort_text: {
        font: (theme.brand.FIELDERS ? "12pt " : "10pt ") + theme.typography.fontFamily,
        color: theme.brand.LYSAGHT ? "grey" : "inherit",
    },
    input: {
        display: "none",
    },
    backdrop: {
        zIndex: 10,
        color: "#fff",
        flexDirection: "column",
    },
}));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        font: "12pt " + theme.typography.fontFamily,
    },
}))(MenuItem);

export default function JobRecallPage(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(window.debug && window.location.href.includes("use_cache") ? false : true);
    const [intialise, setIntialise] = useState(false);
    const [currentBusinessId, setCurrentBusinessId] = useState("");
    const [collection_tab_index, setcollection_tab_index] = useState(0);
    const [dialogData, setDialogData] = useState(false);
    const [viewStyle, setViewStyle] = useState("Grid");
    const [searchFilter, setSearchFilter] = useState("");
    const [containerMode, setContainerMode] = useState("");
    const [sort, setSort] = useState("Last Edited");
    const [sortBy, setSortBy] = useState("LASTEDITED");
    const [dateRange, setDateRange] = useState("allTime");
    const [activeHit, setActiveHit] = useState(0);
    const [archivedHit, setArchivedHit] = useState(0);
    const [deletedHit, setDeletedHit] = useState(0);
    const [testHit, setTestHit] = useState(0);
    const [jobs_to_show, setJobsToShow] = useState(
        window.debug && window.location.href.includes("use_cache")
            ? window.brand === "Fielders"
                ? standard_cent_jobs
                : standard_lld_jobs
            : []
    );

    const app = useSelector((state) => state.app);
    const user = useSelector((state) => state.app.user);
    const config = useSelector((state) => state.config);
    const main_page = useSelector((state) => state.app.MAIN_PAGE);
    const businessList = useSelector((state) => state?.app?.DistributorList);
    const offerings = useSelector((state) => state.app.offerings);

    let defaultMode = "";

    if (user?.Role >= 99) {
        if (window.debug) defaultMode = "Dev";
        else if (window.test) defaultMode = "Test";
    }

    const dateRanges = [
        { Key: "allTime", Display: "All Time" },
        { Key: "currentMonth", Display: "Current Month" },
        { Key: "lastMonth", Display: "Last Month" },
        { Key: "currentFY", Display: "Current FY" },
        { Key: "previousFY", Display: "Previous FY" },
    ];

    // Define a memoized function for searching
    const doSearch = useMemo(
        () =>
            ({ terms, currentBusinessId, collection_tab_index, containerMode, sortBy, NumRecallItems = 50 }) => {
                let business_code =
                    currentBusinessId !== (null || undefined || "") ? currentBusinessId : user?.BusinessDetails?.Code;

                if (!business_code) return;

                let status = "";

                switch (collection_tab_index) {
                    case 1:
                        status = "ARCHIVED";
                        break;
                    case 2:
                        status = "DELETED";
                        break;
                    case 3:
                        status = "TEST";
                        break;
                    default:
                        status = "";
                        break;
                }

                fetchTimeout(API_BASE() + `job/` + business_code, {
                    method: "POST",
                    body: JSON.stringify({
                        Status: status,
                        Container: containerMode,
                        NumItems: NumRecallItems,
                        Filter: terms,
                        SortBy: sortBy,
                    }),
                })
                    .then((response) => response.json())
                    .then((json) => {
                        let jobList = json[0]?.Jobs;
                        setJobsToShow(jobList);

                        const { ACTIVE, DELETED, ARCHIVED, TEST } = json[1]?.ResultExistsIn;
                        setActiveHit(status === "" ? jobList?.length : ACTIVE);
                        setArchivedHit(status === "ARCHIVED" ? jobList?.length : ARCHIVED);
                        setDeletedHit(status === "DELETED" ? jobList?.length : DELETED);
                        setTestHit(status === "TEST" ? jobList?.length : TEST);

                        setTimeout(() => {
                            setLoading(false);
                            dispatch({ type: CLEAR_ALL_DESIGNER_MESSAGE });
                        }, 1000);
                    })
                    .catch((e) => {
                        setTimeout(() => {
                            setLoading(false);
                            dispatch({ type: CLEAR_ALL_DESIGNER_MESSAGE });
                        }, 1000);
                    });
            },
        []
    );

    const delayedSearch = useRef(
        debounce((searchParams) => {
            doSearch(searchParams);
        }, 250)
    ).current;

    // Add all the jobRecall effects
    BusinessIdEffect({
        currentBusinessId,
        setCurrentBusinessId,
        user,
    });

    // ("Active, Archived, Deleted")
    tabIndexEffect({
        doSearch,
        setLoading,
        sortBy,
        main_page,
        searchFilter,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Effect for sorting jobs
    sortByEffect({
        doSearch,
        sortBy,
        loading,
        main_page,
        searchFilter,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Effect for searching jobs
    searchEffect({
        setLoading,
        sortBy,
        searchFilter,
        delayedSearch,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Container Change effect
    containerModeEffect({
        doSearch,
        dispatch,
        API_BASE,
        updateAPP,
        setLoading,
        fetchTimeout,
        setIntialise,
        sortBy,
        main_page,
        searchFilter,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Init Effect
    initialiseEffect({
        API_BASE,
        dispatch,
        updateAPP,
        fetchTimeout,
        setIntialise,
        user,
        intialise,
    });

    // Scrolling effect
    mainPageEffect({
        doSearch,
        setLoading,
        user,
        sortBy,
        loading,
        main_page,
        searchFilter,
        containerMode,
        currentBusinessId,
        collection_tab_index,
        page: app.page,
    });

    const args = [API_BASE, fetchTimeout, currentBusinessId, containerMode, dateRange];
    const { dashData, dashLoading, dashError } = useFetchJobPricesEffect(...args);

    const handleTabChange = (event, newValue) => {
        setcollection_tab_index(newValue);
    };

    let businessesSorted = [];
    businessesSorted.push({
        disabled: true,
        Key: "[BBC]",
        Display: "[BBC Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status !== "ARCHIVED" && item.Type === "BBC")
                businessesSorted.push({
                    Key: item.id,
                    Display: item.id + "-" + item.Name,
                });
        }
    businessesSorted.push({
        disabled: true,
        Key: "[Engineers]",
        Display: "[Engineers Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status !== "ARCHIVED" && item.Type === "Engineer")
                businessesSorted.push({
                    Key: item.id,
                    Display: item.id + "-" + item.Name,
                });
        }
    businessesSorted.push({
        disabled: true,
        Key: "[Customers]",
        Display: "[Customers Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status !== "ARCHIVED" && (!item.Type || (item.Type !== "Engineer" && item.Type !== "BBC")))
                businessesSorted.push({
                    Key: item.id,
                    Display: item.id + "-" + item.Name,
                });
        }
    businessesSorted.push({
        disabled: true,
        Key: "[Archived]",
        Display: "[Archived Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status === "ARCHIVED")
                businessesSorted.push({
                    Key: item.id,
                    Display: (
                        <span style={{ color: "red" }}>
                            <em>{item.id + "-" + item.Name}</em>
                        </span>
                    ),
                });
        }
    if (user?.Role >= 99) businessesSorted.push({ Key: "ALLJOBS", Display: "ALL JOBS" });

    const sortList = ["Last Edited", "First name", "Last name", "Suburb", "JobID", "Status", "Order Status"];

    const handleChange = (event) => {
        setSort(event.target.value);
        switch (event.target.value) {
            case "First name":
                setSortBy("FIRSTNAME");
                break;
            case "Last name":
                setSortBy("LASTNAME");
                break;
            case "Suburb":
                setSortBy("SUBURB");
                break;
            case "JobID":
                setSortBy("JOBID");
                break;
            case "Status":
                setSortBy("STATUS");
                break;
            case "Order Status":
                setSortBy("ORDERSTATUS");
                break;
            default:
                setSortBy("LASTEDITED");
                break;
        }
    };

    const RenderSort = (
        <FormControl variant="standard" style={{ m: 1, minWidth: "120px", marginRight: "10px" }}>
            <InputLabel className={classes.sort_text} id="demo-simple-select-standard-label">
                Sort By
            </InputLabel>
            <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={sort}
                onChange={handleChange}
                label="Sort"
            >
                {sortList.map((val) => (
                    <StyledMenuItem value={val}>{val}</StyledMenuItem>
                ))}
            </Select>
        </FormControl>
    );

    let initialBusinesses = [];
    let linkedBusinessList = [];

    if (user?.BusinessDetails?.Offer?.LinkedBusiness) {
        initialBusinesses.push(...user.BusinessDetails.Offer.LinkedBusiness);
        initialBusinesses.push({
            value: user.BusinessDetails.Code,
            label: user.BusinessDetails.Name,
            state: GetStateFromPOA({ offerings, poa: user.BusinessDetails?.Offer?.Regions?.[0] }),
        });
    }

    if (initialBusinesses.length > 0) {
        initialBusinesses.map((business) =>
            linkedBusinessList.push({
                Display: business.label + " - " + business.state,
                Key: business.value,
                State: business.state,
            })
        );
        linkedBusinessList.push({
            Display: "ALL LINKED ACCOUNTS",
            Key: "ALLJOBS",
            State: "",
        });
    }

    return (
        <div className={classes.root}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    marginBottom: "60px",
                }}
            >
                <div className={classes.page}>
                    <div style={{ padding: "0px 14px" }}>
                        <div style={{ marginBottom: "10px" }}>
                            <span className={classes.header}>Jobs</span>
                            <BSL_Button
                                label="NEW JOB..."
                                onClick={() => {
                                    if (!config?.id || !config?.roofsheet_types) {
                                        alert(
                                            "Configuration not fully loaded yet ... please wait a moment and try again."
                                        );
                                    } else {
                                        dispatch({
                                            type: NEW_JOB,
                                            parameter: null,
                                        });
                                        dispatch(updateAPP(MAIN_PAGE, { page: "New" }));
                                    }
                                }}
                            />
                        </div>
                        <div style={{ display: "flex", alignItems: "baseline", flexWrap: "wrap" }}>
                            <div style={{ width: "450px" }}>
                                {viewStyle !== "Cash" && (
                                    <StyledTabs value={collection_tab_index} onChange={handleTabChange}>
                                        <StyledTab
                                            label={
                                                "Active" +
                                                (collection_tab_index === 0
                                                    ? !loading
                                                        ? " (" + activeHit + ")"
                                                        : ""
                                                    : "") +
                                                (collection_tab_index !== 0 && activeHit == 1 ? " 󠁯•󠁏" : "")
                                            }
                                        />
                                        <StyledTab
                                            label={
                                                "Archived" +
                                                (collection_tab_index === 1
                                                    ? !loading
                                                        ? " (" + archivedHit + ")"
                                                        : ""
                                                    : "") +
                                                (collection_tab_index !== 1 && archivedHit == 1 ? " 󠁯•󠁏" : "")
                                            }
                                        />
                                        {user?.Role >= 99 && (
                                            <StyledTab
                                                label={
                                                    "Deleted" +
                                                    (collection_tab_index === 2
                                                        ? !loading
                                                            ? " (" + deletedHit + ")"
                                                            : ""
                                                        : "") +
                                                    (collection_tab_index !== 2 && deletedHit == 1 ? " 󠁯•󠁏" : "")
                                                }
                                            />
                                        )}
                                        <StyledTab
                                            label={
                                                "Test" +
                                                (collection_tab_index === 3
                                                    ? !loading
                                                        ? " (" + testHit + ")"
                                                        : ""
                                                    : "") +
                                                (collection_tab_index !== 3 && testHit == 1 ? " 󠁯•󠁏" : "")
                                            }
                                        />
                                    </StyledTabs>
                                )}
                            </div>
                            <div
                                style={{
                                    flex: "1 1 0%",
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                {user?.Role >= 99 && (
                                    <div style={{ display: "flex", alignItems: "baseline" }}>
                                        <span className={classes.sort_text}>Container</span>
                                        <BSL_Select
                                            style={{
                                                flex: 1,
                                                maxWidth: "200px",
                                                marginRight: "20px",
                                            }}
                                            value={containerMode ? containerMode : defaultMode}
                                            tight={true}
                                            items={["Dev", "Test", "Prod"]}
                                            onChange={(e) => {
                                                setContainerMode(e.target.value);
                                                if (window.debug) {
                                                    setCurrentBusinessId("ALLJOBS");
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                                {user?.Role >= 91 && (
                                    <div style={{ display: "flex", alignItems: "baseline" }}>
                                        <span className={classes.sort_text}>Account</span>
                                        <BSL_Select
                                            style={{
                                                flex: 1,
                                                maxWidth: "600px",
                                                marginRight: "20px",
                                            }}
                                            value={currentBusinessId ? currentBusinessId : user.BusinessDetails.Code}
                                            tight={true}
                                            items={businessesSorted}
                                            onChange={(e) => {
                                                setCurrentBusinessId(e.target.value);
                                            }}
                                        />
                                    </div>
                                )}
                                {/* Hiding the linked business selector for now (see DES-3161) */}
                                {user?.Role < 91 && linkedBusinessList.length > 1 && 1 === 2 && (
                                    <div style={{ display: "flex", alignItems: "baseline" }}>
                                        <span className={classes.sort_text}>Account</span>
                                        <BSL_Select
                                            style={{
                                                flex: 1,
                                                maxWidth: "600px",
                                                marginRight: "20px",
                                            }}
                                            value={currentBusinessId ? currentBusinessId : "ALLJOBS"}
                                            tight={true}
                                            items={linkedBusinessList}
                                            onChange={(e) => {
                                                setCurrentBusinessId(e.target.value);
                                            }}
                                        />
                                    </div>
                                )}
                                {user?.Role >= 91 && viewStyle === "Cash" && (
                                    <div style={{ display: "flex", alignItems: "baseline" }}>
                                        <span className={classes.sort_text}>Created Date</span>
                                        <BSL_Select
                                            style={{
                                                flex: 1,
                                                maxWidth: "600px",
                                                marginRight: "20px",
                                            }}
                                            value={dateRange}
                                            tight={true}
                                            items={dateRanges}
                                            onChange={(e) => {
                                                setDateRange(e.target.value);
                                            }}
                                        />
                                    </div>
                                )}
                                {viewStyle !== "Cash" && (
                                    <div style={{ display: "flex", width: "350px", alignItems: "baseline" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                alignItems: "anchor-center",
                                            }}
                                        >
                                            <>
                                                {RenderSort}
                                                <div className={classes.search_container}>
                                                    <SearchIcon className={classes.search_icon} />
                                                    <TextField
                                                        id="Search"
                                                        value={searchFilter}
                                                        placeholder="Search"
                                                        type="text"
                                                        onKeyPress={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.target.blur();
                                                            }
                                                        }}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        onChange={(e) => {
                                                            setSearchFilter(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <SegmentedButtonGroup
                                        value={viewStyle}
                                        items={[
                                            {
                                                Key: "Grid",
                                                Display: <AppsIcon />,
                                            },
                                            {
                                                Key: "Table",
                                                Display: <ListIcon />,
                                            },
                                            {
                                                Key: "Cash",
                                                Display: <MonetizationOnIcon />,
                                                hidden: user?.Role < 90,
                                            },
                                        ].filter((item) => !item.hidden)}
                                        onChange={(e, val) => {
                                            setViewStyle(val);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {((loading && viewStyle !== "Cash") || (dashLoading && viewStyle === "Cash")) && (
                            <LinearProgress
                                style={{
                                    marginTop: "0px",
                                    height: "4px",
                                    marginBottom: "-4px",
                                }}
                                color="primary"
                            />
                        )}
                    </div>

                    <RecallQuotesLayout
                        searchFilter={searchFilter}
                        businessCode={currentBusinessId}
                        setLoading={setLoading}
                        loading={loading}
                        containerMode={containerMode}
                        jobs={jobs_to_show}
                        displayMode={viewStyle}
                        updatingLazyLoad={props.updatingLazyLoad}
                        noJobMessage={
                            collection_tab_index === 0
                                ? searchFilter?.length > 0
                                    ? `No jobs found searching for '${searchFilter}'`
                                    : "- No Jobs ... start a new job to begin -"
                                : collection_tab_index === 1
                                ? "- No Jobs Archived -"
                                : collection_tab_index === 2
                                ? "- No Jobs Deleted -"
                                : "- No Jobs in Test -"
                        }
                        dashData={dashData}
                        dashLoading={dashLoading}
                        dashDateRange={dateRange}
                    />
                    {((loading && viewStyle !== "Cash") || (dashLoading && viewStyle === "Cash")) && (
                        <LinearProgress
                            style={{
                                marginTop: "0px",
                                height: "4px",
                                marginBottom: "-4px",
                            }}
                            color="primary"
                        />
                    )}
                    <Message
                        open={app?.designer?.SHOW_MESSAGE}
                        message={
                            app?.designer?.MESSAGE?.message ? app?.designer?.MESSAGE?.message : app?.designer?.MESSAGE
                        }
                        type={app?.designer?.MESSAGE?.type ? app?.designer?.MESSAGE?.type : "error"}
                        // onClose={this.props.toggleDesigner(SHOW_MESSAGE)}
                    />
                    <BSL_Dialog
                        title={dialogData.title}
                        open={dialogData}
                        onClose={() => setDialogData(false)}
                        button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
                        button1Click={() => {
                            setDialogData(false);
                            if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
                        }}
                        button2Text={dialogData?.secondaryActionText}
                        button2Click={() => {
                            setDialogData(false);
                            if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
                        }}
                    >
                        {dialogData.message}
                    </BSL_Dialog>
                </div>
            </div>
        </div>
    );
}
